import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Import styles
import './landing.scss';
import SeoHead from '../../../Components/Common/SeoHead';

// Import components
import Navbar from './Navbar';
import Hero from './Hero';
import LogoMarquee from './LogoMarquee';
import DashboardPreview from './DashboardPreview';
import AIFeatures from './AIFeatures';
import CoreFeatures from './CoreFeatures';
import Integrations from './Integrations';
import HowItWorks from './HowItWorks';
import TrustStats from './TrustStats';
import SupportSection from './SupportSection';
import CTA from './CTA';
import Footer from './Footer';
import GuestChatWidget from './GuestChatWidget';

const CoderomLanding: React.FC = () => {
  const location = useLocation();

  // Scroll to hash on page load or hash change
  useEffect(() => {
    if (location.hash) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const elementId = location.hash.replace('#', '');
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Scroll to top if no hash
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.hash]);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById("back-to-top");
      if (element) {
        element.style.display =
          document.body.scrollTop > 100 || document.documentElement.scrollTop > 100
            ? "block"
            : "none";
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="layout-wrapper landing">
      {/* Navigation */}
      <SeoHead
        title="CodeRom — AI Dropshipping Automation for eBay"
        description="Automate Amazon to eBay dropshipping: AI listing, smart repricing & 24/7 stock sync. Start free."
        canonical="https://www.coderom.com"
      />
      <Navbar />

      {/* Hero section with AI Command Center */}
      <Hero />

      {/* Trusted platforms marquee */}
      <LogoMarquee />

      {/* Dashboard Preview Screenshots */}
      <DashboardPreview />

      {/* AI-Powered Features (main highlight) */}
      <AIFeatures />

      {/* Core Features Grid */}
      <CoreFeatures />

      {/* Integrations - Marketplaces & Suppliers */}
      <Integrations />

      {/* How It Works Timeline */}
      <HowItWorks />

      {/* Trust Stats & Testimonials */}
      <TrustStats />

      {/* Support Section */}
      <SupportSection />

      {/* Final CTA */}
      <CTA />

      {/* Footer */}
      <Footer />

      {/* Guest Chat Widget */}
      <GuestChatWidget />

      {/* Back to top button */}
      <button
        onClick={scrollToTop}
        className="landing-back-top"
        id="back-to-top"
        style={{ display: 'none' }}
        aria-label="Back to top"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="18 15 12 9 6 15" />
        </svg>
      </button>
    </div>
  );
};

export default CoderomLanding;
